import React from 'react'
import PropTypes from 'prop-types'

import {
  BreadcrumbBar,
  BreadcrumbInner,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from './component.styles'

const isModifiedClick = event =>
  event.button !== 0 ||
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey

export const Breadcrumbs = ({ links, onNavigate }) => {
  if (!links?.length) {
    return null
  }

  const handleClick = (event, url) => {
    if (isModifiedClick(event) || typeof onNavigate !== 'function') {
      return
    }

    event.preventDefault()
    onNavigate(url)
  }

  return (
    <BreadcrumbBar aria-label="Breadcrumb" data-testid="breadcrumbs">
      <BreadcrumbInner>
        <BreadcrumbList>
          {links.map((link, index) => (
            <BreadcrumbItem key={`${link.url}-${index}`}>
              {index > 0 && (
                <BreadcrumbSeparator aria-hidden="true">
                  {'>'}
                </BreadcrumbSeparator>
              )}
              <BreadcrumbLink
                data-testid="breadcrumb-link"
                href={link.url}
                onClick={event => handleClick(event, link.url)}
              >
                {link.displayTitle}
              </BreadcrumbLink>
            </BreadcrumbItem>
          ))}
        </BreadcrumbList>
      </BreadcrumbInner>
    </BreadcrumbBar>
  )
}

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      displayTitle: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  onNavigate: PropTypes.func,
}

export default Breadcrumbs
